import { forwardRef } from 'react';
import { ManuscriptsGroupsType } from '@/types/talent/scripts';
import GroupsTabPane from './GroupsTabPane';

export default forwardRef<HTMLDivElement>(function LabelsWrapper(props, ref) {
  return <GroupsTabPane groupsType={ManuscriptsGroupsType.Labels} />;
});
